import React from "react";
import { HiOutlineGlobeAlt } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneSafari } from "../../../lib/sysNavigation/SysNavigation";

type SafariRow = {
  safari_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<SafariRow>
    type={_TYPES_.SAFARI}
    title="Safaris"
    subtitle="Safari tours featured on the public site."
    icon={<HiOutlineGlobeAlt className="h-5 w-5" />}
    addRoute="/data/safari/add"
    editRoute="/data/safari/edit"
    pushOne={pushOneSafari}
    dataKey="safari"
    countKey="safariCount"
    idField="safari_id"
  />
);

export default Overview;
